import axiosClient from "./axiosClient"

export const getStoresForAdministrator = (adminId) => {
	return axiosClient.get(`/administrators/${adminId}/stores`);
}

export const getCompaniesBasicDataForAdministrator = (adminId, active) => {
	let activeParam = "";
	if (active) {
		activeParam = "?active=true"
	}
	return axiosClient.get(`/administrators/${adminId}/companies/basicV2${activeParam}`);
}

export const getCompaniesForAdministrator = (adminId, page = 0, { companyName = '' }, companyId = undefined) => {
	const companyIdParam = (companyId) ? `&companyId=${companyId}` : ''
	return axiosClient.get(`/administrators/${adminId}/companies?textPattern=${companyName}&pageNumber=${page}${companyIdParam}`)
}

export const getAdministratorsForCompany = (companyId, storeIds) => {
	let storeIdsFilter = storeIds && storeIds.length > 0 ? ("&storeIds=" + storeIds.join(",")) : "";
	return axiosClient.get(`/administrators?companyId=${companyId}${storeIdsFilter}`);
}

export const sendWelcomeEmail = (adminId) => {
	return axiosClient.post(`/administrators/${adminId}/send-welcome`)
}

export const deleteAdmin = (adminId) => {
	return axiosClient.delete(`/administrators/${adminId}`)
}

export const resetPassword = (adminId) => {
	return axiosClient.post(`/administrators/${adminId}/send-reset-password`)
}

export const activateAdmin = (adminId) => {
	return axiosClient.put(`/administrators/${adminId}/activate`)
}

export const deactivateAdmin = (adminId) => {
	return axiosClient.put(`/administrators/${adminId}/deactivate`)
}

export const findByUsername = (username, axiosErrorHandler = undefined) => {
	return axiosClient.get(`/administrators/user-name/?username=${username}`, { errorHandler: axiosErrorHandler });
}

export const getCompanyAdminitrators = (company) => {
	return axiosClient.get(`/administrators?companyId=${company}`);
}

export const getStoreAdminitrators = (store) => {
	if (!Array.isArray(store))
		return axiosClient.get(`/stores/${store}/administrators`);
	let storesParam = store.map(s => s.id);
	return axiosClient.get(`/stores/administrators?stores[]=${storesParam}`);
}

export const getAllStoreAdministratorsWithOperation = (storeId, operation) => {
	let operationFilter = operation ? `?operation=${operation}` : "";
	return axiosClient.get(`/stores/${storeId}/administrators/all${operationFilter}`);
}

export const getAllStoresAdministratorsWithOperation = (storeIds, operation) => {
	let storeIdsFilter = storeIds && storeIds.length > 0 ? ("&storeIds=" + storeIds.join(",")) : "";
	let operationFilter = operation ? `?operation=${operation}` : "";
	return axiosClient.get(`/administrators/filter${operationFilter}${storeIdsFilter}`);
}

export const getAdminAvailableProfiles = (adminId) => {
	return axiosClient.get(`administrators/${adminId}/available-profiles`)
}

export const inviteAdmin = (object) => {
	return axiosClient.post(`/administrators/invite`, object);
}

export const updateAdministrator = (object, options = {}) => {
	return axiosClient.post(`/administrators`, object, options);
}

export const checkFirstLogin = (username, token, errorHandler = undefined) => {
	return axiosClient.get('/administrators/first-login/user-name?username=' + username, {
		headers: {
			Authorization: `${token}`
		},
		errorHandler
	});
}

export const setFirstTimeInformation = (object) => {
	return axiosClient.post(`/administrators/first-login/basic-information`, object);
}

export const getAdminById = (adminId) => {
	return axiosClient.get(`/administrators/${adminId}`);
}

export const getChecklist = () => {
	return axiosClient.get(`/administrators/me/checklist`);
}


export const ignoreTask = (id) => {
	return axiosClient.post(`/todotask/ignore/${id}`);
}

export const unignoreTask = (id) => {
	return axiosClient.post(`/todotask/unignore/${id}`);
}

export const hasTodoTask = () => {
	return axiosClient.get("/todotask/hasTodoTask")
}
